export default __webpack_public_path__ + "static/media/crypto-currencies-02.b42115d6.png";